export default "__VITE_ASSET__D57P06S$__"